import { Box } from '@mui/material';

import { getColorStyles, textSwitcherButtonStyle, textSwitcherStyle } from './TextSwitcher.style';

type TextSwitcherPropType = {
  firstOption: string;
  secondOption?: string;
  isSwitcherOn: boolean;
  setSwitcherOn?: (value: boolean) => void;
};

export const TextSwitcher = ({ firstOption, secondOption, isSwitcherOn, setSwitcherOn }: TextSwitcherPropType) => {
  return (
    <Box sx={textSwitcherStyle}>
      <Box
        sx={{
          ...textSwitcherButtonStyle,
          ...getColorStyles(!isSwitcherOn),
        }}
        onClick={() => setSwitcherOn?.(false)}
      >
        {firstOption}
      </Box>
      {secondOption && (
        <Box
          sx={{
            ...textSwitcherButtonStyle,
            ...getColorStyles(isSwitcherOn),
          }}
          onClick={() => setSwitcherOn?.(true)}
        >
          {secondOption}
        </Box>
      )}
    </Box>
  );
};
